/* eslint-disable @typescript-eslint/no-explicit-any */
import autoTable from 'jspdf-autotable';

export function addWestwindPassengierEinweisung(
	doc: any,
	document: any,
	options: { column_width: number; margin_blocks: number; margin_top: number; margin_left: number },
) {
	doc.addPage();
	const pageWidth = doc.internal.pageSize.getWidth();
	const tableWidth = options.column_width * 2 + options.margin_blocks;
	let Ypos = 15;

	// Title - centered
	doc.setFontSize(16);
	doc.text('Passagiereinweisung', pageWidth / 2, Ypos, { align: 'center' });
	Ypos += 12;

	// Instructions text with proper indentation
	doc.setFontSize(10);
	const bulletIndent = options.margin_left + 5;
	const wrapIndent = options.margin_left + 8;

	doc.text('Die Einweisung erfolgt vor der Fahrt:', options.margin_left, Ypos);
	Ypos += 8;

	const bulletPoints = [
		['Der Ballonfahrt stehen keine gesundheitlichen Beeinträchtigungen (Herz, Kreislauf, Knochen,', 'Schwangerschaft) entgegen.'],
		['Robuste Kleidung und feste Schuhe (Umknickgefahr) sind zu tragen'],
		['Es sind alle Anweisungen des Ballonführers ausnahmslos zu befolgen'],
		['Beim Aufbauen, Abrüsten und während der Fahrt besteht absolutes Rauchverbot'],
		['Kein Alkoholgenuss vor und während der Fahrt'],
		['Besteigen des Korbes nur nach Aufforderung des Luftfahrzeugführers'],
		['Festhalten im Korb nur an den dafür vorgesehenen Halteschlaufen. Nicht an den', 'Gasschläuchen'],
		['Das Abwerfen von Gegenständen aus dem Ballon ist verboten'],
		['Vor der Landung sind alle Gegenstände stoßsicher zu verstauen'],
		['Bei der Landung entgegengesetzt der Fahrtrichtung stehen und nicht auf den Korbboden', 'setzen'],
		['Beim Landen leicht gebeugt in die Knie gehen zwecks Abfederung'],
		['Auf Bremsverzögerung bei Bodenberührung vorbereitet sein'],
		['Nicht über die Gasbehälter beugen'],
		['Es muss mit nochmaligem Abheben des Korbes gerechnet werden'],
		['Der Korb darf nur auf ausdrückliche Anweisung des Piloten verlassen werden'],
		['Arme und Hände unter Korbrandhöhe halten, keinesfalls aus dem Korb greifen'],
	];

	bulletPoints.forEach((lines) => {
		doc.text('•', bulletIndent, Ypos);
		doc.text(lines[0], bulletIndent + 3, Ypos);
		Ypos += 4;
		if (lines.length > 1) {
			doc.text(lines[1], wrapIndent, Ypos);
			Ypos += 4;
		}
	});

	Ypos += 8;

	// Declaration text
	doc.setFontSize(10);
	const declarationText = [
		'Ich erkläre, dass ich vom verantwortlichen Luftfahrzeugführer eingewiesen wurde, die Anweisungen',
		'verstanden habe und diese ohne Ausnahme befolgen werde und damit ausdrücklich einverstanden',
		'bin.',
	];

	declarationText.forEach((line) => {
		doc.text(line, options.margin_left, Ypos);
		Ypos += 4;
	});

	// Passenger list table with Name and Unterschrift columns
	const passengers = [];
	document.data.passengers.forEach((p) => {
		passengers.push([
			{ content: p.name, styles: { fontSize: 9 } },
			{ content: '', styles: { fontSize: 9 } },
		]);
	});

	autoTable(doc, {
		head: [['Name', 'Unterschrift']],
		body: passengers,
		startY: Ypos,
		theme: 'grid',
		margin: { left: options.margin_left },
		styles: {
			halign: 'left',
			valign: 'middle',
			fontSize: 9,
			cellPadding: 2,
		},
		tableWidth: tableWidth,
		headStyles: {
			fillColor: '#d3d3d3',
			textColor: '#000000',
			fontSize: 10,
			halign: 'left',
		},
		columnStyles: {
			0: { cellWidth: tableWidth * 0.5 },
			1: { cellWidth: tableWidth * 0.5 },
		},
	});

	Ypos = (doc as any).lastAutoTable.finalY + options.margin_blocks;

	// Balloon and Date row - 4 columns
	const balloonCallSign = document.data.header.balloon;
	const balloonName = document.data.header.balloonType || '';
	const balloonDisplay = balloonName ? `${balloonCallSign} (${balloonName})` : balloonCallSign;

	autoTable(doc, {
		head: [],
		body: [
			[
				{ content: 'Luftfahrzeug', styles: { fontSize: 9, fontStyle: 'bold' } },
				{ content: balloonDisplay, styles: { fontSize: 9 } },
				{ content: 'Datum', styles: { fontSize: 9, fontStyle: 'bold' } },
				{ content: document.data.header.date, styles: { fontSize: 9 } },
			],
		],
		startY: Ypos,
		theme: 'grid',
		margin: { left: options.margin_left },
		styles: {
			halign: 'left',
			valign: 'middle',
			fontSize: 9,
			cellPadding: 2,
		},
		tableWidth: tableWidth,
		columnStyles: {
			0: { cellWidth: tableWidth * 0.25 },
			1: { cellWidth: tableWidth * 0.25 },
			2: { cellWidth: tableWidth * 0.25 },
			3: { cellWidth: tableWidth * 0.25 },
		},
	});

	Ypos = (doc as any).lastAutoTable.finalY + options.margin_blocks;

	// 50mm space for pilot name and signature
	autoTable(doc, {
		head: [],
		body: [[{ content: '', styles: { minCellHeight: 50 }, colSpan: 2 }]],
		startY: Ypos,
		theme: 'grid',
		margin: { left: options.margin_left },
		styles: {
			halign: 'left',
			valign: 'middle',
			fontSize: 9,
			cellPadding: 2,
		},
		tableWidth: tableWidth,
	});

	Ypos = (doc as any).lastAutoTable.finalY;

	// Pilot name and signature row - 2 columns
	autoTable(doc, {
		head: [],
		body: [
			[
				{ content: 'Name Luftfahrzeugführer in Druckschrift', styles: { fontSize: 9, fontStyle: 'bold' } },
				{ content: 'Unterschrift Pilot', styles: { fontSize: 9, fontStyle: 'bold' } },
			],
		],
		startY: Ypos,
		theme: 'grid',
		margin: { left: options.margin_left },
		styles: {
			halign: 'left',
			valign: 'middle',
			fontSize: 9,
			cellPadding: 2,
		},
		tableWidth: tableWidth,
		columnStyles: {
			0: { cellWidth: tableWidth * 0.5 },
			1: { cellWidth: tableWidth * 0.5 },
		},
	});
}
